import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {Range} from "@/modules/redactor/models/utils/Range";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class BoatConfig extends BaseObject {

    constructor() {
        super();

        this._name = null;
        this._easy = 0;
        this._smart = 0;
        this._level = new Range();
        this._resetTime = 0;

        this._deleteTime = 900; //60 * 15
        this._adDeleteSpeedUp = null;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get easy() {
        return this._easy;
    }

    set easy(value) {
        this._easy = value;
    }

    get smart() {
        return this._smart;
    }

    set smart(value) {
        this._smart = value;
    }

    get level() {
        return this._level;
    }

    set level(value) {
        this._level = value;
    }

    get resetTime() {
        return this._resetTime;
    }

    set resetTime(value) {
        this._resetTime = value;
    }

    get deleteTime() {
        return this._deleteTime;
    }

    set deleteTime(value) {
        this._deleteTime = value;
    }

    get adDeleteSpeedUp() {
        return this._adDeleteSpeedUp;
    }

    set adDeleteSpeedUp(value) {
        this._adDeleteSpeedUp = value;
    }



    valid() {

        if (!Number.isInteger(this.easy) || this.easy < 0) {
            return false;
        }

        if (!Number.isInteger(this.smart) || this.smart < 0) {
            return false;
        }

        if (!Number.isInteger(this.resetTime) || this.resetTime < 0) {
            return false;
        }

        if (this.easy + this.smart > 100) {
            return false;
        }

        if (!this.level && !this.level.valid()) {
            return false;
        }

        if (!Number.isInteger(this.deleteTime) || this.deleteTime <= 0) {
            return false;
        }

        if (this.adDeleteSpeedUp && !RedactorUtils.getAdPlacement(this.adDeleteSpeedUp)) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new BoatConfig());
        } else if (target instanceof BoatConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(BoatConfig, {
    _name: alias("name", Schema.primitive()),
    _easy: alias("easy", Schema.primitive()),
    _smart: alias("smart", Schema.primitive()),
    _level: alias("level", Range.schema()),
    _resetTime: alias("reset_time", Schema.primitive()),
    _deleteTime: alias("delete_time", Schema.primitive()),
    _adDeleteSpeedUp: alias("ad_delete_speed_up", Schema.primitive())
});